import {
  useEffect,
  useRef,
  useState
} from 'react'
import { useDispatch } from 'react-redux'
import {
  Image,
  Input,
  Stack,
  Text
} from '@chakra-ui/react'
import { COLORS } from 'utils/styles'
import { ImagesPng } from 'assets/images'
import {
  addImagePosts,
  addImagePostsDraft,
  deletePosts,
  getNotificationMessage,
  getPostsDraft,
  postPosts,
  putPosts,
  postPostsDraft,
  putPostsDraft,
  setOnPostEditor,
  setPostsTypeStatus,
  setExecAutoArchive,
  setClosePane,
  setDeletePostsStatus,
  setOpenBlogForm,
  setPostDraftData,
  setPostDraftId,
  setProfilePostDraftData,
  setRepostThisPostData,
  setPostPostsStatus,
  setPutPostsStatus
} from 'store'
import {
  ACCEPTED_IMG_LIST,
  PENDING,
  REJECTED,
  SUCCEEDED
} from 'utils/constants'
import {
  AnimatePresence,
  motion
} from 'framer-motion'
import { Affinities } from 'components/UserSection/ProfileBlog/Affinities'
import { CustomDatePicker } from 'components/UserSection/ProfileBlog/CustomDatePicker'
import { LoadingSpinier } from 'common/Loading'
import { BlogPreview } from 'components/UserSection/ProfileBlog/BlogPreview'
import {
  base64ToFile,
  resizeImage,
  isMobile,
  convertToUTC,
  convertToOwnTimeZone
} from 'utils/helpers'
import {
  ContinueDraftPopupBtn,
  ContinueDraftPopupText,
  CustomPill,
  DeleteBtn,
  DeletePopupBtn,
  DeletePopupText
} from './styled'
import { TextEditor } from './TextEditor'

const MotionStack = motion(Stack)

export const ProfileBlogForm = ({
  blogParent,
  selectedUser,
  editPostData,
  setEditPostData,
  editMode,
  setEditMode,
  postPostsStatus,
  putPostsStatus,
  addImagePostsStatus,
  affinityList,
  getPostsStatus,
  execAutoArchive,
  openBlogForm,
  postsTypeStatus,
  deletePostsStatus,
  postDraftId,
  getPostsDraftStatus,
  postDraftData,
  profilePostDraftId,
  profilePostDraftData,
  repostThisPostData,
  GoToMarker
}) => {
  const dispatch = useDispatch()
  const [affinitiesArray, setAffinitiesArray] = useState([])
  const [chooseAffi, setChooseAffi] = useState(false)
  const [uploadedImg, setUploadedImg] = useState('')
  const [uploadedImgCount, setUploadedImgCount] = useState(0)
  const parentStackRef = useRef(null)
  const formTitleRef = useRef(null)
  const imageInputRef = useRef(null)
  const [postSubmitType, setPostSubmitType] = useState('')
  const [title, setTitle] = useState('')
  const [body, setBody] = useState([])
  const [postCallOnGoing, setPostCallOnGoing] = useState(false)
  const [pillHoverText, setPillHoverText] = useState('')
  const [pillHoverShow, setPillHoverShow] = useState(false)
  const [chooseDate, setChooseDate] = useState(false)
  const [chosenDate, setChosenDate] = useState('')
  const [activeScroller, setActiveScroller] = useState(null)
  const [openDeletePost, setOpenDeletePost] = useState(false)
  const [showAbsolute, setShowAbsolute] = useState(false)
  const [runAutoSave, setRunAutoSave] = useState(false)
  const [animationFinished, setAnimationFinished] = useState(true)
  const [openContinueDraft, setOpenContinueDraft] = useState(false)
  const postDraftIdRef = useRef(postDraftId)
  const profilePostDraftIdRef = useRef(profilePostDraftId)
  const titleRef = useRef(title)
  const bodyRef = useRef(body)
  const affinitiesRef = useRef(affinitiesArray)
  const autoSaveRef = useRef(null)
  const runAutoSaveRef = useRef(runAutoSave)
  const mediaShouldBeDisabled = profilePostDraftData[0]?.has_repost
    || postDraftData[0]?.has_repost
    || editPostData?.has_repost
    || Object.keys(repostThisPostData).length > 0

  const closeForm = () => {
    dispatch(setOnPostEditor(''))
    setTitle('')
    setBody([])
    setEditMode(false)
    setChooseAffi(false)
    setChooseDate(false)
    setChosenDate(false)
    setAffinitiesArray([])
    setEditPostData({})
    setUploadedImgCount(0)
    setPillHoverShow(false)
    setOpenDeletePost(false)

    setTimeout(() => dispatch(setRepostThisPostData({})), 1000)
  }

  const isBodyEmpty = (thisBody = body) => {
    let noContent = 1

    if (thisBody?.blocks) {
      thisBody?.blocks.forEach((item) => {
        if (
          (
            item.type === 'unstyled'
            && item.text.trim() !== ''
          )
          || item.type === 'atomic'
        ) {
          noContent = 0
        }
      })
    }

    return noContent
  }

  const onGoingApiCall = (type = 0) => {
    const main = getPostsStatus === PENDING
      || putPostsStatus === PENDING
      || postPostsStatus === PENDING
      || deletePostsStatus === PENDING
      || postCallOnGoing
      || openDeletePost

    if (type === 1) {
      return main || (
        isBodyEmpty()
        || title.trim() === ''
      )
    }

    if (type === 2) {
      return main || (
        isBodyEmpty()
        && title.trim() === ''
      )
    }

    if (type === 3) {
      return getPostsStatus === PENDING
      || putPostsStatus === PENDING
      || postPostsStatus === PENDING
      || deletePostsStatus === PENDING
      || postCallOnGoing
    }

    return main
  }

  const convertUrlsToEntities = (data) => {
    const urlRegex = /https?:\/\/[^\s]+/g

    const entityMap = { ...data.entityMap }
    let nextEntityKey = Object.keys(entityMap).length

    const newBlocks = data.blocks.map((block) => {
      const { text } = block
      const matches = [...text.matchAll(urlRegex)]
      const entityRanges = block.entityRanges || []

      matches.forEach((match) => {
        const url = match[0]
        const offset = match.index

        entityMap[nextEntityKey] = {
          type: 'LINK',
          mutability: 'MUTABLE',
          data: { url }
        }

        entityRanges.push({
          offset,
          length: url.length,
          key: nextEntityKey
        })

        nextEntityKey += 1
      })

      return {
        ...block,
        entityRanges
      }
    })

    return {
      blocks: newBlocks,
      entityMap
    }
  }

  const submitForm = async () => {
    if (
      (
        postSubmitType === 'post'
        || postSubmitType === 'plan'
      )
      && (
        title.trim() === ''
        || isBodyEmpty()
      )
    ) {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Title and body field is required',
          isEditProfile: true
        })
      )
      setPostSubmitType('')
    } else if (onGoingApiCall()) {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Post is getting saved',
          isEditProfile: true
        })
      )
    } else if (
      postSubmitType === 'archive'
      && (
        title.trim() === ''
        && isBodyEmpty()
      )
    ) {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Title or body field is required',
          isEditProfile: true
        })
      )
      setPostSubmitType('')
    } else {
      setChooseAffi(false)

      let tempBody = JSON.parse(JSON.stringify(convertUrlsToEntities(body)))
      setPostCallOnGoing(true)

      Promise.all(
        Object.values(tempBody.entityMap).map(async (e) => {
          if (e.type === 'IMAGE' && e.data?.src) {
            const preview = await dispatch(addImagePosts({
              image: base64ToFile(e.data.src, true)
            }))

            e.data.src = preview.payload.fileName
          }
        })
      ).then(async () => {
        if (Object.keys(editPostData).length) {
          const data = {
            type: postSubmitType,
            id: editPostData.profile_id,
            post_id: editPostData.id,
            title,
            body: JSON.stringify(tempBody),
            ...(affinitiesArray.length ? { affinities: [(affinitiesArray.find(() => 1)).id] } : {}),
            ...(postSubmitType === 'plan' ? { planned_at: convertToUTC(chosenDate) } : {})
          }

          await dispatch(putPosts({
            body: data,
            postsTypeStatus,
            ...(
              Object.keys(repostThisPostData).length
                ? { repost_post_id: repostThisPostData?.id }
                : {}
            )
          }))
        } else {
          const data = {
            type: postSubmitType,
            id: selectedUser?.id,
            title,
            body: JSON.stringify(tempBody),
            ...(affinitiesArray.length ? { affinities: [(affinitiesArray.find(() => 1)).id] } : {}),
            ...(postSubmitType === 'plan' ? { planned_at: convertToUTC(chosenDate) } : {}),
            usingDraft: profilePostDraftData.length,
            ...(
              Object.keys(repostThisPostData).length
                ? { repost_post_id: repostThisPostData?.id }
                : {}
            ),
            ...(
              profilePostDraftData[0]?.has_repost
              || postDraftData[0]?.has_repost
              || editPostData?.has_repost
              || Object.keys(repostThisPostData).length
                ? { has_repost: 1 }
                : {}
            )
          }

          await dispatch(postPosts({
            body: data,
            postsTypeStatus
          }))
        }

        if (postSubmitType === 'post') {
          await dispatch(setPostsTypeStatus('posted'))
        } else if (postSubmitType === 'archive') {
          await dispatch(setPostsTypeStatus('archived'))
        } else if (postSubmitType === 'plan') {
          await dispatch(setPostsTypeStatus('scheduled'))
        }

        setPostCallOnGoing(false)
        setPostSubmitType('')
      }).catch(() => {
        setPostCallOnGoing(false)
        setPostSubmitType('')
      })
    }
  }

  const deletePost = async () => {
    await dispatch(deletePosts({
      id: editPostData.profile_id,
      post_id: editPostData.id
    }))

    setTimeout(() => dispatch(setDeletePostsStatus(0)), 1000)

    closeForm()
  }

  const uploadImageWithTimeout = (imageSrc, timeoutMs = 10000) => {
    const uploadPromise = dispatch(addImagePostsDraft({ image: base64ToFile(imageSrc) }))

    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('Image upload timed out')), timeoutMs)
    })

    return Promise.race([uploadPromise, timeoutPromise])
  }

  const autoSaveExistingPost = async () => {
    let tempBody = JSON.parse(JSON.stringify(convertUrlsToEntities(bodyRef.current)))

    if (
      !onGoingApiCall()
      && (
        titleRef.current.trim() !== ''
        || !isBodyEmpty(tempBody)
      )
    ) {
      const postDraftIdCurr = postDraftIdRef.current
      const affinitiesArrayCurr = affinitiesRef.current

      await Promise.all(
        Object.values(tempBody.entityMap).map(async (e) => {
          if (e.type === 'IMAGE' && e.data?.src) {
            try {
              const preview = await uploadImageWithTimeout(e.data.src, 10000)
              e.data.src = preview.payload.fileName
            } catch (err) {
              e.data.src = Math.floor(Math.random() * 999999) + Date.now() + '.jpg'
              console.warn('Image upload failed or timed out, keeping original src:', err)
            }
          }
        })
      )

      const data = {
        id: selectedUser?.id,
        post_id: editPostData?.id,
        post_draft_id: postDraftIdCurr,
        title: titleRef.current,
        body: JSON.stringify(tempBody),
        ...(affinitiesArrayCurr.length
          ? { affinities: [(affinitiesArrayCurr.find(() => 1)).id] }
          : {}
        ),
        ...(
          Object.keys(repostThisPostData).length
            ? { repost_post_id: repostThisPostData?.id }
            : {}
        )
      }

      if (postDraftIdCurr) {
        await dispatch(putPostsDraft({ body: data }))
      } else {
        await dispatch(postPostsDraft({ body: data }))
      }
    }
  }

  const autoSaveNotExistingPost = async () => {
    let tempBody = JSON.parse(JSON.stringify(convertUrlsToEntities(bodyRef.current)))

    if (
      !onGoingApiCall()
      && (
        titleRef.current.trim() !== ''
        || !isBodyEmpty(tempBody)
      )
    ) {
      const profilePostDraftIdCurr = profilePostDraftIdRef.current
      const affinitiesArrayCurr = affinitiesRef.current

      await Promise.all(
        Object.values(tempBody.entityMap).map(async (e) => {
          if (e.type === 'IMAGE' && e.data?.src) {
            try {
              const preview = await uploadImageWithTimeout(e.data.src, 10000)
              e.data.src = preview.payload.fileName
            } catch (err) {
              e.data.src = Math.floor(Math.random() * 999999) + Date.now() + '.jpg'
              console.warn('Image upload failed or timed out, keeping original src:', err)
            }
          }
        })
      )

      const data = {
        id: selectedUser?.id,
        post_draft_id: profilePostDraftIdCurr,
        title: titleRef.current,
        body: JSON.stringify(tempBody),
        ...(affinitiesArrayCurr.length
          ? { affinities: [(affinitiesArrayCurr.find(() => 1)).id] }
          : {}
        ),
        ...(
          Object.keys(repostThisPostData).length
            ? { repost_post_id: repostThisPostData?.id }
            : {}
        )
      }

      if (profilePostDraftIdCurr) {
        await dispatch(putPostsDraft({ body: data }))
      } else {
        await dispatch(postPostsDraft({ body: data }))
      }
    }
  }

  const focusTitleRef = () => {
    if (editMode && formTitleRef.current) {
      formTitleRef.current.blur()
      formTitleRef.current.focus()
    }

    let modalContents = document.querySelector('#chakra-modal--body-user-drawer')
    modalContents.scrollTop = 0
  }

  const checkPicture = (reader, files) => {
    reader.onload = (e2) => {
      const imageElement = document.createElement('img')
      imageElement.src = e2.target.result

      imageElement.onload = () => {
        try {
          if (
            files[0]?.size > 500000
            || imageElement?.width > 500
          ) {
            resizeImage(imageElement, 'b', (resizedImage) => {
              if (resizedImage === null) {
                dispatch(
                  getNotificationMessage({
                    type: REJECTED,
                    message: 'Image upload failed',
                    isEditProfile: true
                  })
                )
              } else {
                setUploadedImg(resizedImage)
              }
            })
          } else {
            setUploadedImg(files[0])
          }
        } catch {
          dispatch(
            getNotificationMessage({
              type: REJECTED,
              message: 'Image upload failed',
              isEditProfile: true
            })
          )
        }
      }
    }
  }

  const handleUploadFile = (e) => {
    const { files } = e.target
    const reader = new FileReader()

    if (uploadedImgCount >= 8) {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Maximum of 8 images only',
          isEditProfile: true
        })
      )
    } else if (files.length === 0 || files[0].size > 10000000) {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'The uploaded image must not exceed 10MB',
          isEditProfile: true
        })
      )
    } else {
      reader.readAsDataURL(files[0])
      checkPicture(reader, files)
    }

    setTimeout(() => {
      imageInputRef.current.value = ''
    }, 500)
  }

  const heightAdjustment = () => {
    if (isMobile()) {
      if (chooseDate) {
        return 'calc(100svh - 50px)'
      }

      if (chooseAffi) {
        return 'calc(100svh - 50px)'
      }

      return 'calc(100svh - 55px)'
    }

    if (chooseDate) {
      return 'calc(100svh - 275px)'
    }

    // If on wide screen and editing a blog, don't show the archived/scheduled/posted
    if (Object.keys(editPostData).length) {
      if (chooseAffi) {
        return 'calc(100svh - 280px)'
      }

      return 'calc(100svh - 335px)'
    }

    return 'calc(100svh - 230px)'
  }

  const countImages = (entityMap) => {
    let imgCount = 0

    if (entityMap.length) {
      entityMap.forEach((e) => {
        imgCount += e.type === 'IMAGE' ? 1 : 0
      })
    }

    setUploadedImgCount(imgCount)
  }

  const draftStillLoading = () => getPostsDraftStatus === PENDING
    || (
      profilePostDraftData.length
      && profilePostDraftData[0]?.imageLoaded < profilePostDraftData[0]?.imageCount
    )

  useEffect(() => {
    setAnimationFinished(false)

    if (editMode && formTitleRef.current) {
      focusTitleRef()

      autoSaveRef.current = setInterval(() => {
        if (runAutoSaveRef.current) {
          setRunAutoSave(false)

          if (Object.keys(editPostData).length && !onGoingApiCall()) {
            autoSaveExistingPost()
          } else {
            autoSaveNotExistingPost()
          }
        }
      }, 10000)

      if (Object.keys(editPostData).length === 0) {
        dispatch(setOnPostEditor('post'))
      } else {
        dispatch(setOnPostEditor('put'))
      }
    } else {
      dispatch(setPostDraftId(null))
      dispatch(setPostDraftData([]))
      dispatch(setProfilePostDraftData([]))
      clearInterval(autoSaveRef.current)
    }
  }, [editMode])

  useEffect(() => {
    if (profilePostDraftData.length) {
      const draftData = profilePostDraftData[0]

      if (draftData?.imageCount === draftData?.imageLoaded) {
        setTitle(draftData.title)
        setBody(draftData.body)
        setAffinitiesArray(draftData.affinities)

        setEditMode(true)
        setOpenContinueDraft(false)
      }
    }
  }, [profilePostDraftData])

  useEffect(() => {
    postDraftIdRef.current = postDraftId
  }, [postDraftId])

  useEffect(() => {
    profilePostDraftIdRef.current = profilePostDraftId
  }, [profilePostDraftId])

  useEffect(() => {
    setRunAutoSave(true)
    titleRef.current = title
  }, [title])

  useEffect(() => {
    setRunAutoSave(true)
    bodyRef.current = body
  }, [body])

  useEffect(() => {
    setRunAutoSave(true)
    affinitiesRef.current = affinitiesArray
  }, [affinitiesArray])

  useEffect(() => {
    runAutoSaveRef.current = runAutoSave
  }, [runAutoSave])

  useEffect(() => {
    if (Object.keys(editPostData).length !== 0) {
      setEditMode(true)
      setTitle(editPostData.title ?? '')
      setBody(editPostData.body)
      setAffinitiesArray(editPostData.affinities)
      focusTitleRef()
      countImages(Object.values(editPostData.body.entityMap))
      dispatch(setOnPostEditor('put'))
      setOpenDeletePost(false)
    }
  }, [editPostData])

  useEffect(() => {
    if (postPostsStatus === SUCCEEDED) {
      dispatch(setPostPostsStatus(0))
      closeForm()
    }
  }, [postPostsStatus])

  useEffect(() => {
    if (putPostsStatus === SUCCEEDED) {
      dispatch(setPutPostsStatus(0))
      closeForm()
    }
  }, [putPostsStatus])

  useEffect(() => {
    if (postSubmitType) {
      submitForm()
    }
  }, [postSubmitType])

  useEffect(() => {
    if (execAutoArchive) {
      if (title.trim() !== '' || !isBodyEmpty()) {
        setPostSubmitType('archive')
      } else {
        dispatch(setClosePane(true))
      }

      dispatch(setExecAutoArchive(false))
    }
  }, [execAutoArchive])

  useEffect(() => {
    if (!openBlogForm && !onGoingApiCall()) {
      if (title.trim() !== '' || !isBodyEmpty()) {
        setPostSubmitType('archive')
      } else {
        closeForm()
      }
    }
  }, [openBlogForm])

  useEffect(() => {
    if (editMode) {
      dispatch(setOpenBlogForm(editMode))
    }

    if (editMode) {
      setTimeout(() => setShowAbsolute(editMode), isMobile() ? 1000 : 700)
    } else {
      setShowAbsolute(editMode)
    }
  }, [editMode])

  return (
    <MotionStack
      initial={{ y: 0, height: '63px' }}
      animate={{ y: 0, height: editMode ? heightAdjustment() : '63px' }}
      transition={{
        type: 'tween',
        duration: isMobile() ? 1 : 0.8
      }}
      onAnimationComplete={() => setAnimationFinished(true)}
      ref={parentStackRef}
      width="calc(100% + 112px)"
      margin="auto auto 0 -56px"
      borderRadius="3px"
      overflow="hidden"
    >
      <Stack
        display="flex"
        background={COLORS.grayGradientTopToBot}
        alignItems="center"
        justifyContent="flex-start"
        flexDirection="row"
        padding="8px"
        borderRadius="5px"
        cursor={editMode ? 'auto' : 'pointer'}
        pointerEvents={animationFinished ? 'auto' : 'none'}
        onClick={() => {
          if (!editMode) {
            if (profilePostDraftId) {
              setOpenContinueDraft(true)
            } else if (animationFinished) {
              setEditMode(true)
            }
          }
        }}
      >
        <Image
          boxSize="45px"
          objectFit="cover"
          src={selectedUser?.profile_picture || ImagesPng.DefaultImage}
          alt="User Image"
          borderRadius="full"
          display="inline-flex"
        />
        {
          editMode
            ? (
              <Input
                ref={formTitleRef}
                background={COLORS.lighterGray}
                color="rgb(100, 100, 100)"
                padding="8px"
                borderRadius={3}
                flex="1"
                maxWidth="calc(100% - 51px)"
                height="35px"
                display="inline-flex"
                alignItems="center"
                placeholder="Title"
                name="blog-title"
                value={title}
                onFocus={() => setActiveScroller(null)}
                onChange={(e) => setTitle(e.target.value)}
              />
            )
            : (
              <Text
                background={COLORS.lighterGray}
                color="rgb(150, 150, 150)"
                padding="8px"
                borderRadius={3}
                flex="1"
                maxWidth="calc(100% - 51px)"
                height="35px"
                display="inline-flex"
                alignItems="center"
                cursor="pointer"
                _hover={{
                  background: 'rgb(220, 220, 220)',
                  border: 'solid 1px black'
                }}
                transition="0.3s"
              >
                Create
              </Text>
            )
        }
      </Stack>

      <Stack
        opacity={openContinueDraft ? 1 : 0}
        display={openContinueDraft ? 'flex' : 'none'}
        transition="1s"
        position="absolute"
        backgroundColor="white"
        padding="15px 5px"
        top="155px"
        right="50px"
        left="50px"
        borderRadius="5px"
        boxShadow="lg"
        zIndex="101"
        justifyContent="center"
        alignItems="center"
        gap="20px"
        sx={{
          '@media (max-height: 550px)': {
            top: '65% !important'
          }
        }}
      >
        <ContinueDraftPopupText>Continue draft?</ContinueDraftPopupText>

        <Stack flexDir="row">
          <ContinueDraftPopupBtn
            onClick={() => { dispatch(getPostsDraft({ id: selectedUser?.id })) }}
            backgroundColor={(draftStillLoading() ? COLORS.gray_op8 : COLORS.gold) + ' !important'}
            pointerEvents={draftStillLoading() ? 'none' : 'auto'}
            cursor={draftStillLoading() ? 'default' : 'pointer'}
          >
            {
              draftStillLoading()
                ? (
                  <LoadingSpinier
                    width="20px"
                    height="20px"
                    marginTop="5px"
                  />
                ) : 'Yes'
            }
          </ContinueDraftPopupBtn>

          <ContinueDraftPopupBtn
            onClick={() => {
              setEditMode(true)
              setOpenContinueDraft(false)
            }}
            backgroundColor={(draftStillLoading() ? COLORS.gray_op8 : COLORS.gold) + ' !important'}
            pointerEvents={draftStillLoading() ? 'none' : 'auto'}
            cursor={draftStillLoading() ? 'default' : 'pointer'}
          >
            No
          </ContinueDraftPopupBtn>

          <ContinueDraftPopupBtn
            onClick={() => setOpenContinueDraft(false)}
            backgroundColor={(draftStillLoading() ? COLORS.gray_op8 : COLORS.gold) + ' !important'}
            pointerEvents={draftStillLoading() ? 'none' : 'auto'}
            cursor={draftStillLoading() ? 'default' : 'pointer'}
          >
            Cancel
          </ContinueDraftPopupBtn>
        </Stack>
      </Stack>

      <AnimatePresence mode="sync">
        {
          editMode
            ? (
              <MotionStack
                exit={{ height: '63px' }}
                transition={{
                  type: 'tween',
                  duration: 0.8
                }}
              >
                <Stack
                  id="blog-form"
                  position="relative"
                >
                  <Input
                    ref={imageInputRef}
                    type="file"
                    accept={ACCEPTED_IMG_LIST}
                    display="none"
                    onChange={handleUploadFile}
                  />
                  <TextEditor
                    allowedFiles={ACCEPTED_IMG_LIST}
                    editMode={editMode}
                    editPostData={editPostData}
                    uploadedImg={uploadedImg}
                    countImages={countImages}
                    setBody={setBody}
                    setUploadedImg={setUploadedImg}
                    chooseAffi={chooseAffi}
                    chooseDate={chooseDate}
                    setActiveScroller={setActiveScroller}
                    getNotificationMessage={getNotificationMessage}
                    dispatch={dispatch}
                    profilePostDraftData={profilePostDraftData}
                    body={body}
                    pillHoverShow={pillHoverShow}
                    pillHoverText={pillHoverText}
                    showAbsolute={showAbsolute}
                    DeleteBtn={DeleteBtn}
                    setOpenDeletePost={setOpenDeletePost}
                    setPillHoverShow={setPillHoverShow}
                    openDeletePost={openDeletePost}
                    onGoingApiCall={onGoingApiCall}
                    setPillHoverText={setPillHoverText}
                    DeletePopupText={DeletePopupText}
                    DeletePopupBtn={DeletePopupBtn}
                    deletePost={deletePost}
                    affinitiesArray={affinitiesArray}
                    setAffinitiesArray={setAffinitiesArray}
                    deletePostsStatus={deletePostsStatus}
                  />
                  {
                    profilePostDraftData[0]?.has_repost
                    || postDraftData[0]?.has_repost
                    || editPostData?.has_repost
                    || Object.keys(repostThisPostData).length > 0
                      ? (
                        <Stack
                          id="repost-blog-preview"
                          maxHeight="300px"
                          border={`solid 2px ${COLORS.gold}`}
                          borderRadius="5px"
                          overflow="scroll"
                          sx={{
                            '::-webkit-scrollbar': {
                              display: 'none'
                            },
                            '-ms-overflow-style': 'none',
                            'scrollbar-width': 'none'
                          }}
                        >
                          <BlogPreview
                            from="editForm"
                            item={
                              Object.keys(repostThisPostData).length
                                ? repostThisPostData
                                : editPostData?.repostPostData
                            }
                            blogParent={blogParent}
                            GoToMarker={GoToMarker}
                            selectedUser={selectedUser}
                          />
                        </Stack>
                      ) : ''
                  }
                </Stack>
                <Stack
                  display={chooseDate ? 'none' : 'flex'}
                  direction="row"
                  padding="2.5px 0px"
                  justifyContent="space-between"
                  margin="-2.5px 0"
                  fontSize="13px"
                  overflowX="auto"
                  sx={{
                    '::-webkit-scrollbar': {
                      display: 'none'
                    },
                    '-ms-overflow-style': 'none',
                    'scrollbar-width': 'none'
                  }}
                >
                  <CustomPill
                    data-name="blog-media"
                    backgroundColor={
                      (
                        onGoingApiCall() || mediaShouldBeDisabled
                          ? COLORS.gray_op8
                          : COLORS.gold
                      ) + ' !important'
                    }
                    pointerEvents={onGoingApiCall() || mediaShouldBeDisabled ? 'none' : 'auto'}
                    onClick={() => {
                      if (!mediaShouldBeDisabled) {
                        imageInputRef.current.click()
                      }
                    }}
                    onMouseEnter={() => {
                      if (!isMobile()) {
                        setPillHoverText('Upload up to 8 images')
                        setPillHoverShow(true)
                      }
                    }}
                    onMouseLeave={() => {
                      if (!isMobile()) {
                        setPillHoverShow(false)
                      }
                    }}
                    onTouchStart={() => {
                      setPillHoverText('Upload up to 8 images')
                      setPillHoverShow(true)
                    }}
                    onTouchEnd={() => setPillHoverShow(false)}
                  >
                    Media
                  </CustomPill>
                  <CustomPill
                    data-name="blog-affinity"
                    backgroundColor={(onGoingApiCall() ? COLORS.gray_op8 : COLORS.gold) + ' !important'}
                    pointerEvents={onGoingApiCall() ? 'none' : 'auto'}
                    onClick={() => {
                      if (chooseAffi) {
                        setChooseAffi(false)
                      } else {
                        setChooseDate(false)
                        setChooseAffi(true)
                      }
                      setPillHoverShow(false)
                    }}
                    onMouseEnter={() => {
                      if (!isMobile()) {
                        setPillHoverText(chooseAffi ? 'Close Affinity Selection' : 'Add an Affinity')
                        setPillHoverShow(true)
                      }
                    }}
                    onMouseLeave={() => {
                      if (!isMobile()) {
                        setPillHoverShow(false)
                      }
                    }}
                    onTouchStart={() => {
                      setPillHoverText(chooseAffi ? 'Close Affinity Selection' : 'Add an Affinity')
                      setPillHoverShow(true)
                    }}
                    onTouchEnd={() => setPillHoverShow(false)}
                  >
                    {chooseAffi ? 'Close' : 'Affinity'}
                  </CustomPill>
                  <CustomPill
                    data-name="blog-archive"
                    backgroundColor={(onGoingApiCall(2) ? COLORS.gray_op8 : COLORS.gold) + ' !important'}
                    pointerEvents={onGoingApiCall(2) ? 'none' : 'auto'}
                    onClick={() => setPostSubmitType('archive')}
                    onMouseEnter={() => {
                      if (!isMobile()) {
                        setPillHoverText('Save to archive')
                        setPillHoverShow(true)
                      }
                    }}
                    onMouseLeave={() => {
                      if (!isMobile()) {
                        setPillHoverShow(false)
                      }
                    }}
                    onTouchStart={() => {
                      setPillHoverText('Save to archive')
                      setPillHoverShow(true)
                    }}
                    onTouchEnd={() => setPillHoverShow(false)}
                  >
                    {
                      postSubmitType === 'archive'
                      && (
                        putPostsStatus !== PENDING
                        || postPostsStatus !== PENDING
                        || addImagePostsStatus !== PENDING
                        || postCallOnGoing
                      )
                        ? (
                          <LoadingSpinier
                            width="15px"
                            height="15px"
                            marginTop="5px"
                          />
                        ) : 'Save'
                    }
                  </CustomPill>
                  <CustomPill
                    data-name="blog-plan"
                    backgroundColor={(onGoingApiCall(1) ? COLORS.gray_op8 : COLORS.gold) + ' !important'}
                    pointerEvents={onGoingApiCall(1) ? 'none' : 'auto'}
                    onClick={() => {
                      setActiveScroller(null)
                      setChooseAffi(false)
                      setChooseDate(true)
                    }}
                    onMouseEnter={() => {
                      if (!isMobile()) {
                        setPillHoverText('Schedule future publishing time')
                        setPillHoverShow(true)
                      }
                    }}
                    onMouseLeave={() => {
                      if (!isMobile()) {
                        setPillHoverShow(false)
                      }
                    }}
                    onTouchStart={() => {
                      setPillHoverText('Schedule future publishing time')
                      setPillHoverShow(true)
                    }}
                    onTouchEnd={() => setPillHoverShow(false)}
                  >
                    Plan
                  </CustomPill>
                  <CustomPill
                    data-name="blog-post"
                    backgroundColor={(onGoingApiCall(1) ? COLORS.gray_op8 : COLORS.gold) + ' !important'}
                    pointerEvents={onGoingApiCall(1) ? 'none' : 'auto'}
                    onClick={() => setPostSubmitType('post')}
                    onMouseEnter={() => {
                      if (!isMobile()) {
                        setPillHoverText('Publish this blog now')
                        setPillHoverShow(true)
                      }
                    }}
                    onMouseLeave={() => {
                      if (!isMobile()) {
                        setPillHoverShow(false)
                      }
                    }}
                    onTouchStart={() => {
                      setPillHoverText('Publish this blog now')
                      setPillHoverShow(true)
                    }}
                    onTouchEnd={() => setPillHoverShow(false)}
                  >
                    {
                      postSubmitType === 'post'
                      && (
                        putPostsStatus === PENDING
                        || postPostsStatus === PENDING
                        || addImagePostsStatus === PENDING
                        || postCallOnGoing
                      )
                        ? (
                          <LoadingSpinier
                            width="15px"
                            height="15px"
                            marginTop="5px"
                          />
                        ) : 'Post'
                    }
                  </CustomPill>
                  <CustomPill
                    data-name="blog-cancel"
                    backgroundColor={(onGoingApiCall() ? COLORS.gray_op8 : COLORS.gold) + ' !important'}
                    pointerEvents={onGoingApiCall() ? 'none' : 'auto'}
                    onClick={() => closeForm()}
                    onMouseEnter={() => {
                      if (!isMobile()) {
                        setPillHoverText('Discard changes')
                        setPillHoverShow(true)
                      }
                    }}
                    onMouseLeave={() => {
                      if (!isMobile()) {
                        setPillHoverShow(false)
                      }
                    }}
                    onTouchStart={() => {
                      setPillHoverText('Discard changes')
                      setPillHoverShow(true)
                    }}
                    onTouchEnd={() => setPillHoverShow(false)}
                  >
                    Cancel
                  </CustomPill>
                </Stack>
                {
                  chooseAffi
                    ? (
                      <Affinities
                        affinitiesArray={affinitiesArray}
                        setAffinitiesArray={setAffinitiesArray}
                        affinityList={affinityList}
                      />
                    ) : ''
                }
                {
                  chooseDate
                    ? (
                      <CustomDatePicker
                        setChooseDate={setChooseDate}
                        setPostSubmitType={setPostSubmitType}
                        setChosenDate={setChosenDate}
                        setPillHoverShow={setPillHoverShow}
                        setPillHoverText={setPillHoverText}
                        postSubmitType={postSubmitType}
                        postPostsStatus={postPostsStatus}
                        putPostsStatus={putPostsStatus}
                        addImagePostsStatus={addImagePostsStatus}
                        postCallOnGoing={postCallOnGoing}
                        plannedAtOrig={
                          Object.keys(editPostData).length !== 0
                          && editPostData.is_planned
                            ? convertToOwnTimeZone(editPostData.planned_at)
                            : ''
                        }
                        activeScroller={activeScroller}
                        setActiveScroller={setActiveScroller}
                        onGoingApiCall={onGoingApiCall}
                      />
                    )
                    : ''
                }
              </MotionStack>
            )
            : ''
        }
      </AnimatePresence>
    </MotionStack>
  )
}
